import { useCircleV4 } from "@circle-react/hooks/useCircleV4";

export const useIsPostsCommentsReactionsEnabled = () => {
  const { isCircleV4 } = useCircleV4();
  return isCircleV4;
};
